import { createSlice } from '@reduxjs/toolkit';

export const formConfig = createSlice({
  name: 'FORM_CONFIG',
  initialState: {}, // declare in store, not here as it will be over written by store

  reducers: {
    setCampaignId(state, action) {
      const { payload } = action;
      const { campaignId } = payload;
      return {
        ...state,
        campaignId,
      };
    },

    setHeaderEnabled(state, action) {
      const { payload } = action;
      const { headerEnabled } = payload;
      return {
        ...state,
        headerEnabled,
      };
    },

    setPhoneNumberCountryCode(state, action) {
      const { payload } = action;
      const { phoneNumberCountryCode } = payload;
      return {
        ...state,
        phoneNumberCountryCode,
      };
    },

    setShouldRenderForm(state, action) {
      const { payload } = action;
      const { shouldRenderForm } = payload;

      state.shouldRenderForm = shouldRenderForm;
    },

    setPageUrl(state, action) {
      const { payload } = action;
      const { pageUrl } = payload;

      state.pageUrl = pageUrl;
    },

    setReferrerUrl(state, action) {
      const { payload } = action;
      const { referrerUrl } = payload;

      state.referrerUrl = referrerUrl;
    },

    setIsIos(state, action) {
      const { payload } = action;
      const { isIos } = payload;

      state.isIos = isIos;
    },

    setIsSafari(state, action) {
      const { payload } = action;
      const { isSafari } = payload;
      state.isSafari = isSafari;
    },

    setIsAndroid(state, action) {
      const { payload } = action;
      const { isAndroid } = payload;
      state.isAndroid = isAndroid;
    },

    setIsDomainInternal(state, action) {
      const isDomainInternal = action.payload?.isDomainInternal ?? false;
      state.isDomainInternal = isDomainInternal;
    },

    setIsCountdownTimerEnabled(state, action) {
      return {
        ...state,
        countdownTimerSettings: {
          ...state.countdownTimerSettings,
          isCountdownTimerEnabled: action.payload.isCountdownTimerEnabled,
        },
      };
    },
  },
});

const { actions, reducer } = formConfig;

export const {
  setCampaignId,
  setHeaderEnabled,
  setPhoneNumberCountryCode,
  setShouldRenderForm,
  setPageUrl,
  setReferrerUrl,
  setIsDomainInternal,
  setIsIos,
  setIsSafari,
  setIsAndroid,
  setIsCountdownTimerEnabled,
} = actions;

export default reducer;
